export const ProtectMobile=(mobile)=>{
    let part1, part2;
    part1 = mobile.substring(0,2);
    part2 = mobile.substring(7,10);
    return  part1+ "*******" + part2;
}